import React from 'react';
import { ProviderMatchClinicalTrial } from '@kyruus/types';
import { FormattedMessage } from '@kyruus/intl';

import {
  ExpertiseSectionContainer,
  ExpertiseSectionTitle,
  ExpertiseList
} from './styles';
import ClinicalTrialsEntry from './clinical-trials-entry';
import messages from '../../lib/messages';

const ClinicalTrials = ({
  clinicalTrials
}: {
  clinicalTrials: ProviderMatchClinicalTrial[];
}): React.ReactElement | null => {
  // do not render if data not present
  if (!clinicalTrials || clinicalTrials.length === 0) {
    return null;
  }

  return (
    <ExpertiseSectionContainer>
      <ExpertiseSectionTitle>
        <FormattedMessage {...messages.clinicalTrialsSectionTitle} />
      </ExpertiseSectionTitle>
      <ExpertiseList>
        {clinicalTrials.map((c, index) => {
          return (
            <ClinicalTrialsEntry
              key={`${c.official_title}_${index}`}
              clinicalTrial={c}
            />
          );
        })}
      </ExpertiseList>
    </ExpertiseSectionContainer>
  );
};

export default ClinicalTrials;
